import { FormattedMessage, useIntl } from 'react-intl';
import Select, { type SelectOption } from '@rio-cloud/rio-uikit/Select';
import { getAvailableCountries, transformToTranslatableOptions } from '../../availableCountries';
import { useAppDispatch, useAppSelector } from '../../../configuration/setup/hooks';
import {
    companyInfoCountryCodeSelector,
    isCompanyLocaleManuallySelected,
    setCompanyInfoField,
} from '../companyInfoSlice';
import { isAppInMaintenanceMode } from '../../../configuration/tmpSlice';
import { countryToLocaleMap } from '../../../configuration/lang/lang';
import { useId } from 'react';

const filterLatamCountries = (countryCodes: string[]) => countryCodes.filter(countryCode => countryCode !== 'BR');
const availableCountries = filterLatamCountries(getAvailableCountries());

export const CountrySelect = (props: { id?: string; required?: boolean }) => {
    const disabled = useAppSelector(isAppInMaintenanceMode);
    const companyLanguageManuallySet = useAppSelector(isCompanyLocaleManuallySelected);
    const countryCode = useAppSelector(companyInfoCountryCodeSelector);
    const dispatch = useAppDispatch();

    const intl = useIntl();

    const generatedId = useId();
    const finalId = props.id || generatedId;

    return (
        <div className={'form-group'}>
            <div className={'col-xs-6 margin-top-10 margin-bottom-5'}>
                <div className={'form-group'}>
                    <label className={'control-label'} htmlFor={finalId}>
                        <FormattedMessage id={'intl-msg:registration.companyData.countryCode'} />
                        {props.required ? '*' : null}
                    </label>
                    <Select
                        disabled={disabled}
                        name={'companyCountry'}
                        data-cy='companyCountry'
                        options={transformToTranslatableOptions(availableCountries, countryCode, intl)}
                        id={finalId}
                        useFilter
                        onChange={(item: SelectOption | undefined) => {
                            if (item) {
                                dispatch(setCompanyInfoField({ fieldName: 'countryCode', value: item.id }));
                                if (!companyLanguageManuallySet) {
                                    dispatch(
                                        setCompanyInfoField({
                                            fieldName: 'language',
                                            value: countryToLocaleMap[item.id.toLowerCase()],
                                        })
                                    );
                                }
                            }
                        }}
                    />
                </div>
            </div>
        </div>
    );
};
